import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Users, BookOpen, Download, ExternalLink } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { motion } from 'framer-motion';

const iconMap = {
  FileText,
  Users,
  BookOpen,
};

export const ResourceCard = ({ resource, index = 0 }) => {
  const IconComponent = iconMap[resource.icon] || FileText;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
    >
      <Card className="group h-full hover:shadow-xl hover:border-primary/30 transition-all duration-300">
        <CardContent className="flex flex-col h-full p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
              <IconComponent className="w-6 h-6 text-primary group-hover:text-primary-foreground transition-colors" />
            </div>
            {resource.featured && (
              <Badge variant="secondary" className="ml-auto">
                Featured
              </Badge>
            )}
          </div>

          <h3 className="text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
            {resource.title}
          </h3>

          <p className="text-sm text-muted-foreground mb-6 flex-grow">
            {resource.description}
          </p>

          <div className="flex gap-3 mt-auto">
            <Button asChild variant="default" size="sm" className="flex-1">
              <a href={resource.href} target="_blank" rel="noopener noreferrer">
                <ExternalLink className="w-4 h-4 mr-2" />
                View PDF
              </a>
            </Button>
            <Button asChild variant="outline" size="sm" className="flex-1">
              <a href={resource.href} download={resource.filename}>
                <Download className="w-4 h-4 mr-2" />
                Download
              </a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};
